import { Box, Grid, Skeleton } from "@mui/material";

/** Home page preview section placeholder (warps, submissions). */
export default function HomePreviewSkeleton({ count = 6, aspectRatio = "1 / 1" }) {
  return (
    <Grid container spacing={1}>
      {Array.from(new Array(count)).map((_, index) => (
        <Grid item xs={4} sm={4} md={2} key={`preview-${index}`}>
          <Skeleton
            variant="rectangular"
            animation="wave"
            sx={{ aspectRatio, borderRadius: 1 }}
          />
        </Grid>
      ))}
    </Grid>
  );
}
